export function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-surface-950 flex flex-col items-center justify-center">
      {/* Logo animation */}
      <div className="relative">
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-accent-400 to-cyan-600 animate-pulse flex items-center justify-center">
          <span className="text-4xl font-bold text-white">₦</span>
        </div>
        {/* Spinning ring */}
        <div className="absolute inset-0 -m-2">
          <svg className="w-24 h-24 animate-spin" viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="rgba(34, 211, 238, 0.2)"
              strokeWidth="4"
            />
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#22d3ee"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="70 200"
            />
          </svg>
        </div>
      </div>
      
      <h1 className="mt-8 text-2xl font-display font-bold text-surface-100">
        FAAC Viz
      </h1>
      <p className="mt-2 text-surface-500">
        Loading allocation data...
      </p>
      
      {/* Progress indicators */}
      <div className="mt-8 flex items-center gap-2">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"
            style={{ animationDelay: `${i * 0.2}s` }}
          />
        ))}
      </div>
    </div>
  );
}

export function ErrorScreen({ message }: { message: string }) {
  return (
    <div className="fixed inset-0 bg-surface-950 flex flex-col items-center justify-center px-4">
      <div className="w-16 h-16 rounded-full bg-danger-500/20 flex items-center justify-center mb-4">
        <svg className="w-8 h-8 text-danger-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
          />
        </svg>
      </div>
      <h2 className="text-xl font-semibold text-surface-100 mb-2">
        Something went wrong
      </h2>
      <p className="text-surface-400 text-center max-w-md mb-6">
        {message}
      </p>
      <button
        onClick={() => window.location.reload()}
        className="btn-primary"
      >
        Reload Page
      </button>
    </div>
  );
}

